import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment-timezone';
import { CommonServiceService } from '../../common-service.service';
import { environment } from 'src/environments/environment';
import { GlobalVariable } from '../../global-variable';
import { Store } from '@ngrx/store';
import { InitialState } from 'src/app/store/reducer';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CookiesService } from '../../cookies.service';

@Component({
  selector: 'app-big-query-search',
  templateUrl: './big-query-search.component.html',
  styleUrls: ['../global-search.component.scss']
})
export class BigQuerySearchComponent implements OnInit {

  misReportFilterForm: FormGroup;
	@ViewChild('searchButton',{static:true}) searchButton : ElementRef;
	minDate = "2023-04-01"
	showIframe : boolean = false;
  maxDate = moment().format('YYYY-MM-DD')
  clientArr: any = []
  keyword = 'name';
  dateFormat = 'YYYY-MM-DD';
  isLocaleDateFormat: boolean = true;
  safeSheetUrl!: SafeResourceUrl;
	adminUrl: string = ''
	isOsakaAdmin: boolean = false
// private readonly publishUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQyCSwGLRa4eCnbsmfxgLqSMdcCtUpHe8QmBJeYcsrlJvtsP74zHk2OQ1Pf8wu2JcyXh0c9XFIHbtDy/pubhtml?widget=true&headers=false';
  publishUrl = 'https://docs.google.com/spreadsheets/d/1nuYJEohj3sa34PvG4u-1OcucCGkcgbF_SU4wx6x8CxY/edit?usp=sharing';

  safeUrl!: SafeResourceUrl;


  constructor(
	public commonService: CommonServiceService,
	private router: Router,
	private formBuilder: FormBuilder,
	private cookiesService: CookiesService,
	private store: Store<InitialState>,
	private sanitizer: DomSanitizer) {
			this.store.select('sharedReducers').subscribe((items)=>{
		if(items.financeYear && items.financeYear.start_date && items.financeYear.end_date){
					this.minDate = items.financeYear.start_date
					this.maxDate = this.commonService.getFinancialSession(moment(items.financeYear.end_date)) < this.commonService.getFinancialSession(moment()) ? 
								moment(items.financeYear.end_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
				} else {
					let current_financial_year =  JSON.parse(sessionStorage.getItem('current_financial_year'))
					if(!current_financial_year) {
						current_financial_year = JSON.parse(localStorage.getItem('current_financial_year'));
					}
					this.minDate = current_financial_year.start_date
					this.maxDate = this.commonService.getFinancialSession(moment(current_financial_year.end_date)) < this.commonService.getFinancialSession(moment()) ? 
								moment(items.financeYear.end_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
				}	  
			})
  }
  
  async ngOnInit() {

	this.misReportFilterForm = this.formBuilder.group({
	  start_date: [this.minDate, this.checkDate('start_date')],
	  end_date: [this.maxDate, this.checkDate('end_date')],
	});
	this.setFormData()
	
	let globalSettingConfig = this.commonService.globalSettingConfig;
	if(!globalSettingConfig || globalSettingConfig.length == 0) {
	  globalSettingConfig = await this.commonService.getGlobalSettings();
	}

	let dateConfig = await this.commonService.getDateFormat('date_format')
	this.dateFormat = dateConfig.dateFormat
	this.isLocaleDateFormat = dateConfig.isLocaleDateFormat;
	this.adminUrl = this.checkOsakaSuperAdmin()
  }

  checkOsakaSuperAdmin(){
		let tenant_data = this.cookiesService.getCookie('SYSTACC_USER_LOGIN_DATA')
		if(tenant_data){
			 let userData = JSON.parse(tenant_data)
		  if(userData.tenant_id && environment.osakaTenantIds.split(',').includes(typeof userData.tenant_id=='number'?userData.tenant_id.toString():userData.tenant_id)){
				if(userData.roles && userData.roles.some(role => role.rolename === 'SUPERADMIN')){
					this.isOsakaAdmin = true
					return 'https://docs.google.com/spreadsheets/d/1zZdJ3k6ooEZVMHdOhCWsMUPPZRF_uAxjDcqyPIzjvIg/edit?usp=sharing'
				}else{
					return ''
				}
			}else{
				return ''
			}
		}
	}

	search(){
		GlobalVariable.openModalStatus = false;
		this.router.navigateByUrl(`/report/big-query`);

	}

  checkDate(formControlName){
		return (control: AbstractControl) => {
			let valid = true
			if(!moment(control.value, 'YYYY-MM-DD').isValid()) {
				valid = false
			} else {
				if(this){
					if (moment(control.value).isBefore(moment(this.minDate, 'YYYY-MM-DD')) || moment(control.value).isAfter(moment(this.maxDate, 'YYYY-MM-DD'))) {
						valid = false
					}
				}
			}
			return !valid ? {[formControlName]: {value: control.value}} : null;
		};
	}
  
  setFormData() {
	let queryParams = localStorage.getItem('activeBigQuerySearchQueryParams')
	if (queryParams != null) {
	  let parsedParams = JSON.parse(queryParams)
	  
	  if (parsedParams.start_date != "") {
		this.misReportFilterForm.controls.start_date.setValue(moment(parsedParams.start_date).format('YYYY-MM-DD') )
	  }
	  if (parsedParams.end_date != "") {
		this.misReportFilterForm.controls.end_date.setValue(moment(parsedParams.end_date).format('YYYY-MM-DD'))
	  }
	}
  }


  openInNewTab() {
    window.open(this.publishUrl, '_blank'); 
  }

  openConsolidateInNewTab(){
	    window.open(this.adminUrl, '_blank'); 
  }

//   search(_: any) {
// 		GlobalVariable.openModalStatus = false;

//     this.safeSheetUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.publishUrl);
//     this.showIframe = true;
//   }

  searchCOnsolidate() {
		GlobalVariable.openModalStatus = false;

    this.safeSheetUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.adminUrl);
    this.showIframe = true;
  }

  getFilteredData(queryParams) {
	this.commonService.getRequestWithQueryParams(`${environment.okountUrl}/reports/gst`, queryParams).subscribe(res => {
	  console.log(res);
	}, err => {
	  console.error(err);
	})
  }

  reset() {
	GlobalVariable.openModalStatus = false;
	this.misReportFilterForm = this.formBuilder.group({
	  start_date: [''],
	  end_date: [''],
	})
	localStorage.removeItem('activeBigQuerySearchQueryParams')
  }

  clickSearchButton(){
		this.searchButton.nativeElement.click()

	}

}

